import { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import {
  KEY_PRACTICE_JOURNALING,
  KEY_PRACTICE_JOURNALING_WP
} from '../../../common/api'
import {
  getJournalingPractices,
  getPracticeDetails,
  getDailyJournals
} from '../../../common/api/Practices'
import PracticeIntroVideo from '../../PracticeIntroVideo'
import PracticesList from '../../PracticesList'
import {
  ROUTE_ACTIVITIES_ALL,
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL,
  ROUTE_CHAT_GENERAL
} from '../../../common/helpers/Paths'
import {
  saveUserEvent,
  EVENT_CATEGORY_JOURNALING,
  EVENT_ACTION_PAGEVIEW,
  EVENT_VALUE_ALL
} from '../../../common/api/UserEvents'
import FloatingButtons from '../FloatingButtons/FloatingButtons'
import AlertDismissable from 'components/common/messaging/AlertDismissable'
import useFetchAllList from '../../../common/hooks/useFetchAllList'
import Loading from 'templates/Loading'
import ChatCTA from 'components/chat/ChatCTA/ChatCTA'

export default function JournalList({ cache, setHeaderTitle, setReturnPath }) {
  const [hasDismissedJournalingAlert, setHasDismissedAlert] = useState(
    localStorage.getItem('hasDismissedJournalingAlert') === 'true'
  )

  // Get practice and intro video details and define our baseUrluseFetchAll
  const introVideoData = getPracticeDetails(KEY_PRACTICE_JOURNALING)
  const cacheKey = 'ROUTE_ACTIVITIES_JOURNALING_ALL'
  const cacheKeyDaily = 'ROUTE_ACTIVITIES_JOURNALING_DAILY'
  //call useFetchAllList and set new data variable
  const { data, isLoaded } = useFetchAllList(
    getJournalingPractices,
    cache,
    cacheKey
  )

  const dataDailyJournals = useFetchAllList(
    getDailyJournals,
    cache,
    cacheKeyDaily
  )

  // get all journaling practices (daily journals and journaling prompts)
  const handleDismissAlert = () => {
    setHasDismissedAlert(true)
    // TODO: Save this in DB
    localStorage.setItem('hasDismissedJournalingAlert', 'true')
  }

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Update Header
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_ALL)

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_JOURNALING,
      EVENT_ACTION_PAGEVIEW,
      EVENT_VALUE_ALL
    )
  }, [data, cache, setHeaderTitle, setReturnPath])

  return (
    <Loading isLoaded={!isLoaded && !dataDailyJournals.isLoaded}>
      <Container className='journaling-list-container'>
        <PracticeIntroVideo data={introVideoData} />
        <ChatCTA
          message="Get Mia's help"
          uri={`${ROUTE_CHAT_GENERAL}/create?returnPath=${ROUTE_ACTIVITIES_JOURNALING_ALL}`}
        />
        <AlertDismissable
          defaultShow={!hasDismissedJournalingAlert}
          title={'We care about your privacy'}
          onDismiss={handleDismissAlert}
          message={`We utilize state-of-the-art security and end-to-end encryption
  to make sure your journals stay private to you. Your journals
  are always encrypted, so they can never be viewed by anyone
  but yourself.`}
        />
        <h3 className='mt-5'>Daily Journals</h3>
        <PracticesList
          baseUrl={ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL}
          data={dataDailyJournals.data}
          lockedReturnPath={ROUTE_ACTIVITIES_JOURNALING_ALL}
          practiceType={KEY_PRACTICE_JOURNALING_WP}
        />
        <h3 className='mt-5'>Journaling Prompts</h3>
        <PracticesList
          baseUrl={ROUTE_ACTIVITIES_JOURNALING_ALL}
          data={data}
          practiceType={KEY_PRACTICE_JOURNALING_WP}
        />
        <FloatingButtons />
      </Container>
    </Loading>
  )
}
